import StaffRegistrationStatusPage from './StaffRegistrationStatus';

export default StaffRegistrationStatusPage;
